import {
    Logo,
    Ruler,
    Shapes,
    Markers,
    Slideshow,
    Editor,
    Arrow,
    Book,
    Triangles,
} from './background';
import {
    Splash,
    Description,
    Mobile,
    Canvas,
    Publications,
    Organisations,
    Contact,
    Tool,
    Cases,
} from './content';

export default [
    {
        slug: 'home',
        theme: 'dark',
        Section: Splash,
        Background: Logo,
    },
    {
        slug: 'magazine',
        theme: 'light',
        Section: Mobile,
        Background: Ruler,
    },
    {
        slug: 'description',
        theme: 'light',
        Section: Description,
        Background: Shapes,
    },
    {
        slug: 'canvas',
        theme: 'black',
        Section: Canvas,
        Background: Markers,
    },
    {
        slug: 'tool',
        theme: 'black',
        Section: Tool,
        Background: Book,
    },
    {
        slug: 'cases',
        theme: 'black',
        Section: Cases,
        Background: Triangles,
    },
    {
        slug: 'publications',
        theme: 'light',
        Section: Publications,
        Background: Slideshow,
    },
    {
        slug: 'organisations',
        theme: 'light',
        Section: Organisations,
        Background: Editor,
    },
    {
        slug: 'contact',
        theme: 'primary',
        Section: Contact,
        Background: Arrow,
    },
];
